var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","color":"primary","loading":_vm.loading,"disabled":_vm.loading},on:{"click":_vm.startGuide}},[_c('v-icon',[_vm._v("mdi-help-circle-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }